"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var UsersDataProvider = function () {
  function UsersDataProvider(Users) {
    "ngInject";

    (0, _classCallCheck3.default)(this, UsersDataProvider);
    this.UsersService = Users;
  }

  (0, _createClass3.default)(UsersDataProvider, [{
    key: "getUsers",
    value: function getUsers(data) {
      return this.UsersService.loadUsers(data).then(function (result) {
        return result;
      });
    }
  }, {
    key: "getUser",
    value: function getUser(id) {
      return this.UsersService.getUser(id).then(function (result) {
        return result;
      });
    }
  }, {
    key: "getOrders",
    value: function getOrders(data) {
      return this.UsersService.getOrders(data).then(function (result) {
        return result;
      });
    }
  }, {
    key: "getComments",
    value: function getComments(id) {
      return this.UsersService.getComments(id).then(function (resp) {
        return resp;
      });
    }
  }, {
    key: "saveComments",
    value: function saveComments(data) {
      return this.UsersService.saveComments(data).then(function (resp) {
        return resp;
      });
    }
  }, {
    key: "removeComment",
    value: function removeComment(id) {
      return this.UsersService.removeComment(id).then(function (resp) {
        return resp;
      });
    }
  }]);
  return UsersDataProvider;
}();

// WEBPACK FOOTER //


exports.default = UsersDataProvider;


/** WEBPACK FOOTER **
 ** ./client/app/modules/users/services/user.dataprovider.service.js
 **/